import dayjs from 'dayjs';

import type { Schema } from '../../../../../types/DirectusSchema';
import type { FormData } from '../types/FormData.ts';

export const apiToForm = (data: Schema['events'][0]): FormData => {
  return {
    id: data.id ?? '',
    name: data.name ?? '',
    category: typeof data.category === 'object' && data.category?.id ? data.category.id.toString(10) : '',
    tags:
      data?.target_audiences?.map((item) =>
        typeof item === 'string'
          ? ''
          : typeof item?.target_audiences_id === 'object'
            ? item.target_audiences_id.id.toString(10)
            : (item?.target_audiences_id ?? ''),
      ) ?? [],
    shortDescription: data.short_description ?? '',
    longDescription: data.long_description?.toString() ?? '',
    websiteLink: data.venue_website ?? '',
    // instagramLink: data.instagram_link ?? '',
    // tiktokLink: data.tiktok_link ?? '',
    // eventType: parseEventType(data.type),
    venue: typeof data.venue === 'object' && data.venue?.id ? data.venue.id.toString(10) : '',
    // onlineLink: data.online_link ?? '',
    image: typeof data.image === 'string' ? data.image : '',
    // spotifyLink: data.spotify_link ?? '',
    start: data.start ? dayjs(data.start).toDate() : new Date(),
    end: data.end ? dayjs(data.end).toDate() : new Date(),
    ticketshopLink: data.ticket_sale_url ?? '',
    eventGroupId:
      typeof data.events_group === 'object'
        ? (data.events_group?.id?.toString(10) ?? '')
        : // With `fields: ['*']` Directus returns the raw FK, which is a number for
          // `events_group`. Without this branch it fell through to '', which disabled the
          // series lookup and made "Remove all" delete only the first event of a series.
          (data.events_group?.toString() ?? ''),
  };
};
